module.exports = __webpack_public_path__ + "media/Video4.a293c7d2.mp4";